import {Pageable} from '../model/core/pageable.model';
import {StringUtils} from './string.utils';
import {Moment} from 'moment-timezone';

export type UrlParameterType = number | string | Moment | boolean;

export class UrlBuilder {

    private readonly _path: string;
    private _parameters: UrlParameter[] = [];
    private _order: Sort;
    private _pageable: Pageable;

    constructor(path: string) {
        this._path = path;
    }

    public addParameterDateBetween(from: Moment, to: Moment){
        this.addParameter('date', StringUtils.join(',', from, to), Operator.BETWEEN);
        return this;
    }

    public addParameter(parameterName: string, parameterValue?: UrlParameterType, operator?: Operator) {
        if (parameterValue == null || parameterValue === undefined) {
            return this;
        }
        this._parameters.push(new UrlParameter(parameterName, parameterValue, operator));
        return this;
    }

    public withOrder(sort: Sort) {
        this._order = sort;
        return this;
    }

    public withPagination(pageable: Pageable) {
        this._pageable = pageable;
        return this;
    }


    public build(): string {
        let url = this._path;
        if (this._pageable) {
            url += withPagination(this._pageable, url === this._path);
        }
        this._parameters.forEach(param => url += addParameter(param, url === this._path));
        if (this._order) {
            url += withOrder(this._order, url === this._path);
        }
        return url;
    }
}

function addParameter(param: UrlParameter, firstParameter: boolean) {
    return chainParameter(firstParameter) + param._name + '=' + param.valueParameter();
}


function withOrder(param: Sort, firstParameter: boolean) {
    return chainParameter(firstParameter) + 'sortBy=' + param._name + ':' + param._order;
}

function withPagination(pageable: Pageable, firstParameter: boolean) {
    return chainParameter(firstParameter) + 'page=' + pageable.pageNumber + '&size=' + pageable.pageSize;
}
function chainParameter(firstParameter: boolean) {
    return firstParameter ? '?' : '&';
}

export class Sort {
    constructor(name: string, order: Order) {
        this._name = name;
        this._order = order;
    }
    _name: string;
    _order: Order;

    public static fromString(sortString: string): Sort {
        if (sortString?.indexOf(':') > 0) {
            const splitted: string[] = sortString.split(':');
            return new Sort(splitted[0], Order[splitted[1]]);
        }
        return undefined;
    }

    public static buildString(name: string, order: Order) {
        return name + ':' + (order === Order.ASCENDING ? 'ASCENDING' : 'DESCENDING');
    }
}



export class UrlParameter {
    constructor(name: string, value: UrlParameterType, operator= Operator.EQUALS) {
        this._name = name;
        this._value = value;
        this._operator = operator;
    }
    _name: string;
    _value: UrlParameterType;
    _operator: Operator;

    valueParameter(): string {
        let valueParameter = '';
        if (this._operator) {
            valueParameter += this._operator + ':';
        }
        valueParameter += this._value;
        valueParameter = valueParameter.replace('+', '%2B');
        return valueParameter;
    }
}



export enum Operator {
    LIKE = 'like',
    LESS_OR_EQUAL = 'le',
    LESS = 'lt',
    EQUALS = 'eq',
    GREATER_OR_EQUAL = 'ge',
    GREATER = 'gt',
    BETWEEN = 'between',
    IN = 'in',
    NOT = 'not',
    NOT_IN = 'notin'
}

export enum Order {
    ASCENDING= 'asc' ,
    DESCENDING = 'desc',
}

export enum Period {
   BEGIN, END
}
